import React from 'react'
import { Phone, ArrowRight } from 'lucide-react'
import Reveal from './Reveal.jsx'
import { CTA_CSS } from './ctaSection.css.js'

const base = (window.wpData?.siteUrl ?? '').replace(/\/$/, '')

export default function CTASection({
  contact,
  title = 'Ready to Set Sail?',
  sub = 'Speak with our cruise specialists to plan your perfect Ha Long Bay voyage. We handle every detail - from transfers to exclusive shore excursions.',
  injectCSS = true,
}) {
  const phone = contact?.phone || '+84 203 384 9999'
  return (
    <>
      {injectCSS && <style>{CTA_CSS}</style>}
      <section className="hp-cta">
        <div className="hp-cta__inner">
          <Reveal variant="fade-up">
            <h2 className="hp-cta__title">{title}</h2>
            <p className="hp-cta__sub">{sub}</p>
            <div className="hp-cta__phone"><Phone size={20} strokeWidth={1.5} /> {phone}</div>
            <div className="hp-cta__actions">
              <a href={`${base}/contact-us`} className="ljn-btn-primary">Contact Us <ArrowRight size={14} strokeWidth={1.5} /></a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  )
}
